import React, { useState } from 'react';
import Popover from '../../../UI/Popover/Popover';
import Attachment from "../../../../assets/Icon/Attachment"; 
import BLicon from "../../../../assets/Icon/BLicon";
import { baseFileURL } from '../../../../Api';
import cl from './InvoiceModal.module.css';

const AgentInvoice = ({ defaultSale, isView, onFileSelect }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(null);

  const handleFileChange = e => {
    const selected = e.target.files[0];
    setFile(selected);
  };

  const handleSave = () => {
    if (file) {
      onFileSelect(file);
    }
    setIsModalOpen(false);
  };

  return (
    <Popover
      placement="bottom"
      fullWidth
      isOpen={isModalOpen}
      content={
        <div style={{ minWidth: '200px' }}>
          <div className={cl.modalHead}>
            <h3 style={{display:'flex'}}>
              <span style={{ fontSize: 14, fontWeight: 600 }}>
                Agent Invoice
              </span>
            </h3>
          </div>
          <div>
            <div className={cl.groupInput}>
              <input
                type="file"
                onChange={handleFileChange}
                disabled={isView}
                className={cl.input}
              />
              {/* Display selected file name */}
              {file && (
                <div className={cl.fileName}>
                  Selected file: {file.name}
                </div>
              )}
            </div>
            {defaultSale.agent_invoice && (
              <a
                className={cl.link2ed}
                href={baseFileURL + defaultSale.agent_invoice}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Attachment/> BL გადმოწერა
              </a>
            )}
            <div className={cl.flexend}>
              <button
                className={cl.btnPrimary}
                onClick={e => {
                  e.stopPropagation();
                  handleSave();
                  // simulate trigger click to close Popover
                  const wrapper = e.target.closest('span[style*="position: relative"]');
                  if (wrapper) {
                    const trigger = wrapper.querySelector(':scope > span');
                    if (trigger) trigger.click();
                  }
                }}
              >
                შენახვა
              </button>
            </div>
          </div>
        </div>
      }
    >
      <span
        className={`${cl.btnContainerTop} ${cl.greenbtn}`}
        onClick={() => setIsModalOpen(true)}
      >
        <span className={cl.icon}><BLicon/></span>
        <div className={cl.btnTxt}>Agent Invoice</div>
        {defaultSale.agent_invoice && (
          <a
            className={cl.linkinvoice}
            href={baseFileURL + defaultSale.agent_invoice}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Attachment/>
          </a>
        )}
      </span>
    </Popover>
  );
};

export default AgentInvoice;
